import { browserHistory } from 'react-router'
import * as firebase from 'firebase'
import {
    noResultDispatch,
    ResultDispatch,
    loadingDispatch
} from '../reducers/container/resultDispatch'
import axios from 'axios';




export function getResultAction() {
    return dispatch => {
        // console.log("red alert")
        let downloadList = [];
        dispatch(loadingDispatch())
        firebase.database().ref("result/" + 'solo1on1/').once("value", (solo1on1) => {
            let solo1on1Data = solo1on1.val();

            let userUid = firebase.auth().currentUser.uid;
            // console.log(solo1on1Data, 'solo1on1Data')
            for (var key in solo1on1Data) {
                // console.log(solo1on1Data[key], 'key')
                for (var prop in solo1on1Data[key]) {
                    // console.log(solo1on1Data[key][prop], 'key')
                    if (solo1on1Data[key][prop].generatorId === userUid) {
                        downloadList.push(solo1on1Data[key][prop])
                    }
                }

            }
            // console.log(downloadList, "downloadList")
            firebase.database().ref("result/" + 'team/').once("value", (team) => {
                let teamData = team.val();

                // console.log(solo1on1Data, 'solo1on1Data')
                for (var key in teamData) {
                    // console.log(solo1on1Data[key], 'key')
                    for (var prop in teamData[key]) {
                        // console.log(solo1on1Data[key][prop], 'key')
                        if (teamData[key][prop].generatorId === userUid) {
                            downloadList.push(teamData[key][prop])
                        }
                    }

                }
                // console.log(downloadList, "downloadList")
                if (downloadList.length !== 0) {
                    dispatch(loadingDispatch())
                    // console.log(downloadList, "downloadList")
                    dispatch(ResultDispatch(downloadList))
                } else {
                    dispatch(loadingDispatch())
                    // console.log("Download list is empty")
                    dispatch(noResultDispatch("Result list is empty..."))
                }
            })
        })
    }
}


export function getResultSheet(action) {
    return dispatch => {
        console.log("action", action)
        dispatch(loadingDispatch())
        axios.post('https://us-central1-mageproject-beadb.cloudfunctions.net/resultSheet', action)
            .then((success) => {
                console.log("downloading.....now.............")
                setTimeout(() => {
                    dispatch(downloadingFile(action))
                }, 3000)
            })
            .catch((error) => {
                dispatch(loadingDispatch())
                throw error
            })
    }
}

function downloadingFile(action) {
    return dispatch => {
        var storageRef = firebase.storage().ref('result/').child(action.quizName + ".xlsx")
        storageRef.getDownloadURL()
            .then((url) => {
                // console.log(url, 'url')
                window.location = url;
                dispatch(loadingDispatch())
                setTimeout(() => {
                    storageRef.delete()
                }, 10000)
            })
            .catch((err) => {
                dispatch(loadingDispatch())
                throw err
            })
    }
}


// WEBPACK FOOTER //
// ./src/action/resultAction.jsx